import SALogger from "@al/sa-logger";
import JsCookie from "js-cookie";
import logger from '../logger/index';
import { getRouteConfig } from "../utils/path";
import runtime from "../utils/runtime";
import { currentRouteChannelEnabled } from '../utils'

const countryMap = {
  ID: "1",
  MY: "2",
  PH: "3",
  VN: "4",
};

//优先从cookie推到国家
let countryCode = JsCookie.get("countryCode") || "ID";
let sa

function init() {
  if (sa) {
    return sa
  }

  const env = runtime.get('env')
  const isProd = env === "prod"

  sa = new SALogger({
    needReport: true,
    autoTrack: false,
    server_url: isProd ? "https://sc.akulaku.com/sa?project=production" : "https://sc.akulaku.com/sa",
    show_log: !isProd,
    prefix: "Aku",
    app_name: "Akulaku",
    self_uid: "-1",
    country_id: countryMap[countryCode],
    country_name: countryCode,
  });

  return sa
}

export default function readyTransport(options, metricsPredicate) {
  if (!currentRouteChannelEnabled('sa')) {
    return false;
  }

  let predicateResult = true;
  if (metricsPredicate && typeof metricsPredicate === 'function') {
    predicateResult = metricsPredicate(options.Page_stayTime) && metricsPredicate(options.Page_loadTime);
  }

  if (!predicateResult) {
    return false;
  }

  const shouldLog = runtime.get('shouldLog')
  const shouldReport = runtime.get('shouldReport')
  const { event, ...rest } = options

  if (shouldLog) {
    logger.info(
`
[performance-collect]:
  event: ${event},
  data: ${JSON.stringify(rest, null, 4)}
`
    )
  }

  if (shouldReport) {
    transport({
      ...options,
    })
  }

  return true
}

function transport(options) {
  if (!sa) {
    init()
  }
  const { event, ...rest } = options

  sa.hasPrefixTrack(event, rest)
}
